export default [
  {
    name: 'title',
    steps: [
      {
        name: 'title-overview',
        label: 'Title',
        iconClass: 'fas fa-magic',
        primary: true,
        component: () => import('./TitleStep/TitleOverviewStep'),
        navigation: {
          back: null,
          next: { label: 'Next', to: 'venue-overview' },
          skip: null,
        },
      },
    ]
  },
  {
    name: 'venue',
    steps: [
      {
        name: 'venue-overview',
        label: 'Availability',
        iconClass: 'fas fa-share-alt',
        primary: true,
        component: () => import('./VenueStep/VenueOverviewStep'),
        navigation: {
          back: { label: 'Back', to: 'title-overview' },
          next: { label: 'Next', to: 'network-overview' },
          skip: null,
        },
      },
      {
        name: 'venue-onsite-form',
        label: 'Venue Onsite Form',
        iconClass: null,
        primary: false,
        parent: 'venue-overview',
        component: () => import('./VenueStep/VenueFormStep'),
        navigation: {
          back: { label: 'Back', to: 'venue-overview' },
          next: { label: 'Next', to: 'venue-calendar' },
          skip: null,
        },
      },
      {
        name: 'venue-remote-form',
        label: 'Venue Remote Form',
        iconClass: null,
        primary: false,
        parent: 'venue-overview',
        component: () => import('./VenueStep/VenueFormStep'),
        navigation: {
          back: { label: 'Back', to: 'venue-overview' },
          next: { label: 'Next', to: 'venue-calendar' },
          skip: null,
        },
      },
      {
        name: 'venue-ongoing-form',
        label: 'Venue Ongoing Form',
        iconClass: null,
        primary: false,
        parent: 'venue-overview',
        component: () => import('./VenueStep/VenueFormStep'),
        navigation: {
          back: { label: 'Back', to: 'venue-overview' },
          next: { label: 'Next', to: 'venue-calendar' },
          skip: null,
        },
      },
      {
        name: 'venue-calendar',
        label: 'Venue Calendar',
        iconClass: null,
        primary: false,
        parent: 'venue-overview',
        component: () => import('./VenueStep/VenueCalendarStep'),
        navigation: {
          back: { label: 'Back', to: null },
          next: { label: 'Next', to: 'venue-overview' },
          skip: null,
        },
      },
      {
        name: 'venue-availability-window',
        label: 'Venue Availability Window',
        iconClass: null,
        primary: false,
        parent: 'venue-overview',
        component: () => import('./VenueStep/VenueAvailabilityWindowStep'),
        navigation: {
          back: { label: 'Back', to: 'venue-calendar' },
          next: { label: 'Next', to: 'venue-overview' },
          skip: null,
        },
      },
    ]
  },
  {
    name: 'network',
    steps: [
      {
        name: 'network-overview',
        label: 'Recess Network',
        iconClass: 'fas fa-share-alt',
        primary: true,
        component: () => import('./NetworkStep/NetworkOverviewStep'),
        navigation: {
          back: { label: 'Back', to: 'venue-overview' },
          next: { label: 'Next', to: 'item-distribution-overview' },
          skip: null,
        },
      },
    ],
  },
  {
    name: 'item-distribution',
    steps: [
      {
        name: 'item-distribution-overview',
        label: 'Item Distribution',
        iconClass: 'fas fa-gifts',
        primary: true,
        component: () => import('./ItemDistributionStep/ItemDistributionOverviewStep'),
        navigation: {
          back: { label: 'Back', to: 'network-overview' },
          next: { label: 'Next', to: 'onsite-activation-overview' },
          skip: null,
        },
      },
      {
        name: 'item-distribution-form',
        label: 'Setup Item Distribution',
        iconClass: null,
        primary: false,
        parent: 'item-distribution-overview',
        component: () => import('./ItemDistributionStep/ItemDistributionFormStep'),
        navigation: {
          back: { label: 'Nevermind', to: 'item-distribution-overview' },
          next: { label: 'Save', to: 'item-distribution-overview' },
          skip: null,
        },
      },
    ],
  },
  {
    name: 'onsite-activation',
    steps: [
      {
        name: 'onsite-activation-overview',
        label: 'Onsite Activation',
        iconClass: 'fas fa-store',
        primary: true,
        component: () => import('./OnsiteActivationStep/OnsiteActivationOverviewStep'),
        navigation: {
          back: { label: 'Back', to: 'item-distribution-overview' },
          next: { label: 'Next', to: 'partnership-overview' },
          skip: null,
        },
      },
      {
        name: 'onsite-activation-form',
        label: 'Setup Onsite Activation',
        iconClass: 'fas fa-gifts',
        primary: false,
        parent: 'onsite-activation-overview',
        component: () => import('./OnsiteActivationStep/OnsiteActivationFormStep'),
        navigation: {
          back: { label: 'Nevermind', to: 'onsite-activation-overview' },
          next: { label: 'Save', to: 'onsite-activation-overview' },
          skip: null,
        },
      },
    ]
  },
  {
    name: 'partnership',
    steps: [
      {
        name: 'partnership-overview',
        label: 'Partnership',
        iconClass: 'far fa-handshake',
        primary: true,
        component: () => import('./PartnershipStep/PartnershipOverviewStep'),
        navigation: {
          back: { label: 'Back', to: 'onsite-activation-overview' },
          next: { label: 'Setup Partnership', to: 'partnership-storage' },
          skip: null,
        },
      },
      {
        name: 'partnership-storage',
        label: 'Storage',
        iconClass: 'fas fa-boxes',
        primary: false,
        parent: 'partnership-overview',
        component: () => import('./PartnershipStep/PartnershipStorageStep'),
        navigation: {
          back: { label: 'Back', to: 'partnership-overview' },
          next: { label: 'Next', to: 'partnership-prohibited-categories' },
          skip: null,
        },
      },
      {
        name: 'partnership-prohibited-categories',
        label: 'Prohibited',
        iconClass: 'fas fa-window-close',
        primary: false,
        parent: 'partnership-overview',
        component: () => import('./PartnershipStep/PartnershipProhibitedCategoriesStep'),
        navigation: {
          back: { label: 'Back', to: 'partnership-storage' },
          next: { label: 'Next', to: 'partnership-catex' },
          skip: null,
        },
      },
      {
        name: 'partnership-catex',
        label: 'Exclusivity',
        iconClass: 'fas fa-award',
        primary: false,
        parent: 'partnership-overview',
        component: () => import('./PartnershipStep/PartnershipCatexStep'),
        navigation: {
          back: { label: 'Back', to: 'partnership-prohibited-categories' },
          next: { label: 'Next', to: 'partnership-special-terms' },
          skip: null,
        },
      },
      {
        name: 'partnership-special-terms',
        label: 'Terms',
        iconClass: 'fas fa-pencil-alt',
        primary: false,
        parent: 'partnership-overview',
        component: () => import('./PartnershipStep/PartnershipSpecialTermsStep'),
        navigation: {
          back: { label: 'Back', to: 'partnership-catex' },
          next: { label: 'Next', to: 'partnership-demographics' },
          skip: null,
        },
      },
      {
        name: 'partnership-demographics',
        label: 'Demographics',
        iconClass: 'fas fa-users',
        primary: false,
        parent: 'partnership-overview',
        component: () => import('./PartnershipStep/PartnershipDemographicsStep'),
        navigation: {
          back: { label: 'Back', to: 'partnership-special-terms' },
          next: { label: 'Next', to: 'partnership-sponsor' },
          skip: null,
        },
      },
      {
        name: 'partnership-sponsor',
        label: 'Sponsors',
        iconClass: 'fas fa-handshake',
        primary: false,
        parent: 'partnership-overview',
        component: () => import('./PartnershipStep/PartnershipSponsorStep'),
        navigation: {
          back: { label: 'Back', to: 'partnership-demographics' },
          next: { label: 'Preview', to: null },
          skip: null,
        },
      },
    ]
  },
]